import isNumeric from "antd/lib/_util/isNumeric";

export interface SectionScoreDatum {
    id?: number;
    title: string;
    score: number | null;
    index?: number;
}

export interface SectionScoreSeriesDatum extends SectionScoreDatum {
    series: 'First' | 'Best';
}

export interface SectionFirstBestDatum extends SectionScoreDatum {
    first_score?: number | null;
    best_score?: number | null;
}

export const buildFirstBestSeriesData = (
    firstData: SectionScoreDatum[],
    bestData: SectionScoreDatum[],
): SectionScoreSeriesDatum[] => {
    return [
        ...firstData.map((item) => ({...item, series: 'First' as const})),
        ...bestData.map((item) => ({...item, series: 'Best' as const})),
    ].sort((d1, d2) => {
        const i1 = isNumeric(d1.index) ? Number(d1.index) : Number.POSITIVE_INFINITY;
        const i2 = isNumeric(d2.index) ? Number(d2.index) : Number.POSITIVE_INFINITY;
        if (i1 !== i2) return i1 - i2;
        return d1.title.localeCompare(d2.title);
    });
};

export const mergeSectionScoresByTitle = (
    firstData: SectionScoreDatum[],
    bestData: SectionScoreDatum[],
): SectionFirstBestDatum[] => {
    const sectionsByTitle = new Map<string, SectionFirstBestDatum>();

    firstData.forEach((section) => {
        sectionsByTitle.set(section.title, {
            ...section,
            first_score: section.score,
        });
    });

    bestData.forEach((section) => {
        const existing = sectionsByTitle.get(section.title);
        sectionsByTitle.set(section.title, {
            ...(existing || section),
            title: section.title,
            best_score: section.score,
        });
    });

    return Array.from(sectionsByTitle.values()).sort((a, b) => {
        const aBest = isNumeric(a.best_score) ? Number(a.best_score) : Number.POSITIVE_INFINITY;
        const bBest = isNumeric(b.best_score) ? Number(b.best_score) : Number.POSITIVE_INFINITY;
        if (aBest !== bBest) return aBest - bBest;
        return a.title.localeCompare(b.title);
    });
};
